import { Accordion, Checkbox, Flex, P } from '@dnb/eufemia';
import styled from '@emotion/styled';

import { useUrlFilters } from '@/hooks/useUrlFilters';
import { EventWithUserDataResponse } from '@/openapi/schema';
import { removeStringFromArray } from '@/utils/arrayUtils';

import { ServiceDomainOptions } from '../apis/components/ApiPage/helpers';

interface Props {
  serviceDomainCount: Record<string, number>;
  serviceDomainOptions: ServiceDomainOptions;
}

const StyledAccordion = styled(Accordion)`
  --accordion-header-margin-vertical: 0.2rem;
  --accordion-header-wrapper-margin--icon-right: 0;
  --accordion-content-margin: 0.3rem 0 1rem 0;
  --accordion-title-font-weight: 500;
`;

export function serviceDomainCount(filteredEvents: EventWithUserDataResponse[]) {
  return filteredEvents.reduce<Record<string, number>>((acc, api) => {
    const id = api.serviceDomain?.id;
    if (id) acc[id] = (acc[id] ?? 0) + 1;
    return acc;
  }, {});
}

export const SERVICE_DOMAIN_KEY = 'serviceDomains';

export default function ServiceDomainFilter({ serviceDomainCount, serviceDomainOptions }: Props) {
  const { getSelectedKeysFromURL, updateFilterInURL } = useUrlFilters();

  const selectedServiceDomains = getSelectedKeysFromURL(SERVICE_DOMAIN_KEY, serviceDomainOptions);

  const handleChange = (checked: boolean, key: string) => {
    const updated = checked ? [...selectedServiceDomains, key] : removeStringFromArray(selectedServiceDomains, key);

    updateFilterInURL(SERVICE_DOMAIN_KEY, updated, serviceDomainOptions);
  };

  return (
    <StyledAccordion icon_position="right" title="Service domain" top="medium" variant="default">
      <Flex.Vertical>
        {serviceDomainOptions.map((serviceDomain) => (
          <Checkbox
            checked={selectedServiceDomains.includes(serviceDomain.selectedKey)}
            key={serviceDomain.selectedKey}
            label={
              <>
                <P>{`${serviceDomain.content[1]} (${serviceDomainCount[serviceDomain.selectedKey] ?? 0})`}</P>
                <P slant="italic">{serviceDomain.content[0]}</P>
              </>
            }
            onChange={({ checked }) => handleChange(checked, serviceDomain.selectedKey)}
            size="medium"
            space={{ top: 'xx-small', bottom: 'xx-small' }}
          />
        ))}
      </Flex.Vertical>
    </StyledAccordion>
  );
}
